<template lang="pug">
v-dialog(v-model="popupDialog" fullscreen hide-overlay transition="dialog-bottom-transition")
  v-card
    v-toolbar(dense flat color="accent white--text")
      v-btn(icon @click.native="popupDialog = false" dark)
        v-icon close
      v-fade-transition(mode="out-in")
        v-toolbar-title Update Module
      v-spacer
      v-toolbar-items
        v-btn(flat @click.native="update" dark) Update
    div(v-html="diffHtml")
</template>

<script>
import { mapState } from 'vuex';
import diff2html from 'diff2html';
import Base from '../views/Base';
import { publish } from '../../api';

export default {
    name: 'UpdateCEModuleDialog',
    extends: Base,

    props: {
        showDialog: { type: Boolean, required: true, default: false },
        diff: { type: String, required: true },
        publishId: { type: Number, required: true },
        moduleId: { type: Number, required: true }
    },

    data() {
        return {
            popupDialog: false,
            diffHtml: ''
        };
    },

    computed: {
        ...mapState({
            fileNameMap: state => state.navigation.fileNameMap
        })
    },

    watch: {
        showDialog(value) {
            if (value) {
                this.popupDialog = true;
            }
        },

        diff(value) {
            // this.convertFileNameToPageName();
            this.convertDiff();
        },

        popupDialog(value) {
            if (!value) {
                this.$emit('closed');
            }
        }
    },

    methods: {
        async convertDiff() {
            if (this.loading) return;
            this.setLoading(true);

            try {
                const diffOptions = {
                    fileName: '',
                    inputFormat: 'diff', // diff || json
                    outputFormat: 'side-by-side', // line-by-line || side-by-side
                    showFiles: true,
                    matching: 'none', // lines || words || none
                    synchronisedScroll: false,
                    matchWordsThreshold: 0.25,
                    matchingMaxComparisons: 2500
                };

                this.diffHtml = diff2html.Diff2Html.getPrettyHtml(
                    this.diff,
                    diffOptions
                );
            } catch (err) {
                this.showErrorAlert(err.message);
            } finally {
                this.setLoading(false);
            }
        },

        async update() {
            if (this.loading) return;
            this.setLoading(true);
            try {
                const response = await publish.merge(
                    this.publishId,
                    this.moduleId
                );
                const hasConflicts = response.data.hasConflicts;
                // Fetch the context keys again - there might be new ones
                // from the update
                if (!hasConflicts) {
                    await this.$store.dispatch('clientContext/getAll');
                    await this.$store.dispatch('published/getAllAppliedUpdates');
                    await this.$store.dispatch('published/getAllComplispaceUpdates');
                }
                this.$emit('updateParent');
                this.popupDialog = hasConflicts;
            } catch (err) {
                this.showErrorAlert(err.message);
            } finally {
                this.setLoading(false);
                this.popupDialog = false;
            }
        },

        convertFileNameToPageName() {
            const pageEntries = Object.entries(this.fileNameMap[this.moduleId]);
            if (pageEntries) {
                pageEntries.forEach((entry) => {
                    this.diff = this.diff.replace(entry[0], entry[1]);
                });
            }
        }
    }
};
</script>

<style>
  @import '../../../node_modules/diff2html/dist/diff2html.css';
</style>



// WEBPACK FOOTER //
// src/components/content/UpdateCEModuleDialog.vue